<template>
  <Dialog v-model:visible="showCreativeModal" class="w-11/12 bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="!showSelectPostDialogMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="w-full text-gray-900 font-semibold">
        {{lang['components']['Dialog']['SelectCreativeDialog']['dialog_title']}}
        <button
          class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
          @click="creative_data_update()">
          <i class="pi pi-refresh"></i>>{{lang['components']['Dialog']['SelectCreativeDialog']['update_button']}}
        </button>
      </div>
    </template>
    <!-- <div class="flex flex-wrap justify-between space-1-2 px-8">
      <Dropdown v-model="type" :options="types" optionLabel="name" optionValue="code" placeholder="所有貼文類型" class="w-1/4 rounded-md" />
      <div class=" bg-white rounded-md flex items-center w-3/5 p-2 shadow-sm border border-gray-200">
        <i class="pi pi-search"></i>
        <input v-model="searchKey" type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent">
      </div>
      <button class="text-white px-4 whitespace-no-wrap rounded-xl transition duration-300 bg-blue-900 ml-4" @click="searchMaterial()">搜尋</button>
    </div> -->
    <div
      class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
      <DataTable :value="dataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
            dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
            :currentPageReportTemplate="lang['components']['Dialog']['SelectCreativeDialog']['datatable_page_info']" responsiveLayout="scroll">
        <Column selectionMode="multiple"></Column>
        <Column field="name" :header="lang['components']['Dialog']['SelectCreativeDialog']['field_a']" :sortable="true" headerStyle="width: 30%">
          <template #body="slotProps">
            <div class="text-sm" v-html="slotProps.data.name"></div>
          </template>
        </Column>
        <Column field="date" :header="lang['components']['Dialog']['SelectCreativeDialog']['field_b']" :sortable="true"></Column>
        <Column field="ad_type" :header="lang['components']['Dialog']['SelectCreativeDialog']['field_c']" :sortable="true"></Column>
        <Column field="call_to_action_type" :header="lang['components']['Dialog']['SelectCreativeDialog']['field_d']" :sortable="true"></Column>
        <Column field="message" :header="lang['components']['Dialog']['SelectCreativeDialog']['field_e']" :sortable="true"></Column>
        <!-- <Column field="touch" header="觸及人數" :sortable="true"></Column>
        <Column field="interactive" header="互動指數" :sortable="true">
          <template #body="slotProps">
            <div class="flex"><div class="star" v-for="n in slotProps.data.interactive" :key="n">★</div></div>
          </template>
        </Column>
        <Column field="link" header="連結指數" :sortable="true">
          <template #body="slotProps">
            <div class="flex"><div class="star" v-for="n in slotProps.data.link" :key="n">★</div></div>
          </template>
        </Column> -->
      </DataTable>
    </div>
    <template #footer>
      <div class="w-full justify-end py-4 border-t border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showCreativeModal=false">{{lang['components']['Dialog']['SelectCreativeDialog']['cancel_button']}}</button>
        <button
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          style="margin-right:72px;"
          @click="selected_click()">{{lang['components']['Dialog']['SelectCreativeDialog']['yes_button']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  // import { ref } from 'vue';
  import Dialog from 'primevue/dialog';
  import Dropdown from 'primevue/dropdown';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'SelectPostDialog',
    components: {
      Dialog,
      Dropdown,
      DataTable,
      Column,
      Loading
    },
    props: {
      showCreative: {
        type: Boolean,
        default: false
      },
      viewDatalist: {
        type: Object
      },
      creativesDatalist: {
        type: Object
      },
      prviewCreativesDatalist: {
        type: Object
      },
      pageId: {
        type: String
      },
      goalsObjectiveData: {
        type: String
      },
      specialAdCategory: {
        type: String
      },
      showCreativeDialogMyside: {
        type: Boolean
      },
      lang:{
        type: Object
      }
    },
    data() {
      return {
        showSelectPostDialogMyside: false,
        type: null,
        searchKey: null,
        types: [],
        items: null,
        selectedCustomers: null,
        setPageId: null,
        dataTableList:[],
        // items: [{
        //     name: '新廣告活動',
        //     date: '2021/01/01',
        //     like: '100',
        //     comment: '200',
        //     share: '300',
        //     touch: '123',
        //     interactive: '5',
        //     link: '2',
        //   },
        //   {
        //     name: '新廣告活動',
        //     date: '2021/01/01',
        //     like: '100',
        //     comment: '200',
        //     share: '300',
        //     touch: '123',
        //     interactive: 4,
        //     link: 2,
        //   }
        // ]
      }
    },
    methods: {
      selected_click () {
        // console.log(this.selectedCustomers);
        // console.log(this.pageIdData);

        let data_length = this.selectedCustomers.length

        if(data_length <= 10){
          this.showSelectPostDialogMyside = false;

          axios
            .post('https://www.autoturn.net/api/campaign_form_fb_creatives_mark.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              page_id: this.pageIdData,
              objective: this.goalsObjectiveData,
              special_ad_category: this.specialAdCategoryData,
              creatives: this.selectedCustomers
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // console.log('selected_click');
                // console.log(response.data.return_data);
                // console.log(response.data.return_prview);
                // this.items = response.data.return_data
                if(this.goalsObjectiveData == 'MESSAGES'){
                  console.log('message data');
                  this.$emit('update:creativesMessageDatalist', response.data.return_data)
                  this.$emit('update:prviewCreativesMessageDatalist', response.data.return_prview)
                } else {
                  console.log('not message data');
                  this.$emit('update:creativesDatalist', response.data.return_data)
                  this.$emit('update:prviewCreativesDatalist', response.data.return_prview)
                }  

                this.showCreativeModal = false

                this.selectedCustomers = null

                this.$emit('childCreativesMaterialGetData', true);
              }

              this.showSelectPostDialogMyside = true;
            });
        } else {
          Swal.fire(
                      this.lang['components']['Dialog']['SelectCreativeDialog']['methods']['selected_click']['have_not_length_swal_title'],
                      this.lang['components']['Dialog']['SelectCreativeDialog']['methods']['selected_click']['have_not_length_swal_text'],
                      "warning"
                    )
        }
      },
      creative_data_update(){
        // console.log('creative_data_update');

        if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
          this.showSelectPostDialogMyside = false;
          this.dataTableList = [];

          axios
            .post('https://www.autoturn.net/api/campaign_form_fb_creatives.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              page_id: this.pageId,
              objective: this.goalsObjectiveData,
              type: 'update',
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                // console.log('posts_data');
                // console.log(response.data.return_data);
                this.dataTableList = response.data.return_data
              }

              this.showSelectPostDialogMyside = true;
            });
        } else {
          Swal.fire(
                    this.lang['components']['Event']['Material']['methods']['creatives_data']['no_pageId_swal_title'],
                    this.lang['components']['Event']['Material']['methods']['creatives_data']['no_pageId_swal_text'],
                    'error'
                  )
        }
      }
    },
    // setup(props) {
    //   console.log("Setup props:", props);

    //   watch((first, second) => {
    //     console.log("Watch function called with args:", first, second);
    //   });

    //   watch(props.selected, (first, second) => {
    //     console.log(
    //       "Watch props.selected function called with args:",
    //       first,
    //       second
    //     );
    //   });

    //   return {props};
    // },
    // setup() {
    //     const selectedCustomers = ref();
    //     return { selectedCustomers }
    // },
    watch: {
      'pageIdData': function(v){
        // console.log('selectpostdialog pageIdData:'+v);
      },
      'viewDatalist': function(v){
        // console.log('selectpostdialog viewDatalist:'+v);
        this.dataTableList = v;
      },
      'showCreativeDialogMyside': function(v){
        //console.log('showCreativeDialogMyside:'+v);
        this.showSelectPostDialogMyside = v
      }
    },
    computed: {
      showCreativeModal: {
        get: function () {
          return this.showCreative
        },
        set: function (value) {
          this.$emit('update:showCreative', value)
        }
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      pageIdData: {
        get: function () {
          return this.pageId
        },
        set: function (value) {
          this.$emit('update:pageIdData', value)
        },
      },
      specialAdCategoryData: {
        get: function () {
          return this.specialAdCategory
        },
        set: function (value) {
          this.$emit('update:specialAdCategoryData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scope>
  .star {
    &:nth-child(1) {
      color: #FADB76;
    }
    &:nth-child(2) {
      color: #2FCABD;
    }
    &:nth-child(3) {
      color: #72B6F4;
    }
    &:nth-child(4) {
      color: #6298D7;
    }
    &:nth-child(5) {
      color: #1D619F;
    }
  }
</style>